import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../../firebase';
import { collection, query, where, getDocs, orderBy, addDoc, serverTimestamp } from 'firebase/firestore';
import { Card } from '../UI/Card';

export const ReviewsList = ({ userId, currentUserId }) => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchReviews = async () => {
      if (!userId) { 
        setLoading(false); 
        return; 
      }
      try {
        // Try with orderBy first
        const q = query(
          collection(db, 'reviews'),
          where('reviewedUserId', '==', userId),
          orderBy('createdAt', 'desc')
        );
        const snapshot = await getDocs(q);
        const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setReviews(data);
      } catch (err) {
        console.log('Using fallback query (no orderBy)');
        // Fallback without orderBy
        try {
          const q = query(
            collection(db, 'reviews'),
            where('reviewedUserId', '==', userId)
          );
          const snapshot = await getDocs(q);
          let data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          // Sort client-side
          data = data.sort((a, b) => {
            const aTime = a.createdAt?.seconds || 0;
            const bTime = b.createdAt?.seconds || 0;
            return bTime - aTime;
          });
          setReviews(data);
        } catch (fallbackErr) {
          console.error('Fallback also failed:', fallbackErr);
        }
      } finally {
        setLoading(false);
      }
    };
    fetchReviews();
  }, [userId]);

  const handleReport = (reviewId, reviewerId, reviewerName) => {
    navigate(`/report-review/${reviewId}/${reviewerId}/${encodeURIComponent(reviewerName)}`);
  };

  const renderStars = (rating) => {
    const fullStars = Math.floor(rating || 0);
    const stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(
        <span key={i} style={{ color: i < fullStars ? '#fbbf24' : '#d1d5db' }}>
          ★
        </span>
      );
    }
    return stars;
  };

  if (loading) return <p style={{textAlign:'center', padding:'1rem'}}>Loading reviews...</p>;
  if (reviews.length === 0) return <p style={{color:'#666', fontStyle:'italic'}}>No reviews yet.</p>;

  return (
    <div className="reviews-section">
      <h3>📝 Reviews ({reviews.length})</h3>
      {reviews.map(review => (
        <Card key={review.id} className="review-card">
          <div className="review-header">
            <span 
              className="reviewer-name" 
              onClick={() => navigate(`/profile/${review.reviewerId}`)}
            >
              {review.reviewerName}
            </span>
            <div className="review-rating">
              {renderStars(review.rating)}
            </div>
          </div>
          {review.comment && <p className="review-comment">{review.comment}</p>}
          {review.attachments && review.attachments.length > 0 && (
            <div className="review-attachments">
              {review.attachments.map((file, i) => (
                <a key={i} href={file.url} target="_blank" rel="noopener noreferrer" className="review-file">
                  📎 {file.name}
                </a>
              ))}
            </div>
          )}
          <div className="review-footer">
            <span className="review-date">{review.createdAt?.toDate?.().toLocaleDateString()}</span>
            {userId === currentUserId && (
              <button onClick={() => handleReport(review.id, review.reviewerId, review.reviewerName)} className="report-review-btn">
                🚩 Report
              </button>
            )}
          </div>
        </Card>
      ))}
    </div>
  );
};
